export const REACT_APP_MYRIAD_TOS_URL =
  'https://myriad.com/privacy/terms-of-use/';
export const REACT_APP_MYRIAD_PRIVACY_POLICY_URL =
  'https://myriad.com/privacy-policy/';
